var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"new"},[_c('v-container',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('v-card',{attrs:{"align":"center"}},[_c('Tab',{staticClass:"tab",attrs:{"articleId":_vm.articleId}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }